import React from 'react';

import FreeText from './../overlays/FreeText';
import Crawl from './../overlays/Crawl';
import LineUp from './../overlays/LineUp';
import Overlay from './../overlays/Overlay'
import Bowl from './../overlays/Bowl'

class IncastContentTVMapping extends React.Component {

  constructor(props) {
    super(props);
  }

  render () {
    return (
      <>
      <Overlay stateName="IncastContentTV_content" display={this.props.display} theme={this.props.theme} overlayConf="IncastContentTV_content"/>
      <Crawl stateName="IncastContentTV_main_crawl" display={this.props.display}  theme={this.props.theme} overlayConf="IncastContentTV_main_crawl"/>
      <Overlay stateName="IncastContentTV_top_weather_clock" display={this.props.display} theme={this.props.theme} overlayConf="IncastContentTV_top_weather_clock"/>

      <Overlay stateName="IncastContentTV_main_content_news" display={this.props.display} theme={this.props.theme} overlayConf="IncastContentTV_main_content_news"/>
      <Overlay stateName="IncastContentTV_main_content_appointment" display={this.props.display} theme={this.props.theme} overlayConf="IncastContentTV_main_content_appointment"/>
      <Overlay stateName="IncastContentTV_main_content_weather" display={this.props.display} theme={this.props.theme} overlayConf="IncastContentTV_main_content_weather"/>
      <Overlay stateName="IncastContentTV_main_content_time" display={this.props.display} theme={this.props.theme} overlayConf="IncastContentTV_main_content_time"/>
      <Overlay stateName="IncastContentTV_main_content_flights" display={this.props.display} theme={this.props.theme} overlayConf="IncastContentTV_main_content_flights"/>
      <Overlay stateName="IncastContentTV_main_content_image_news" display={this.props.display} theme={this.props.theme} overlayConf="IncastContentTV_main_content_image_news"/>
      <Overlay stateName="IncastContentTV_main_2nd_info" display={this.props.display} theme={this.props.theme} overlayConf="IncastContentTV_main_2nd_info"/>
    </>

    );
  }

}
export default IncastContentTVMapping;
